// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__V8rAs","box":"WorkspacesBox_box__3kAG9","node":"WorkspacesBox_node__27qwp"};